import {isInViewport, loadLibrary} from "../modules/Util";
import {LIB_URL} from '../App';

$(document).ready(function() {
    /* анимация для всех устройств */
    $('.js-scroll-animation-all-devices').each(function() {
        scrollAnimation($(this));
    });

    App.W.on('scrolled', function() {
        $('.js-scroll-animation-all-devices:not(.animate__animated)').trigger('animate-visible');
    });

    App.W.on('resized', function () {
        $('.js-scroll-animation-all-devices:not(.animate__animated)').trigger('animate-visible');
    });

    /* анимация для дектопных устройств */
    if (!isTouchDevice()) {
        $('.js-scroll-animation-list').each(function() {
            let scrollingListItems = $(this).find('.js-scroll-animation');
            for (let i=0; i<scrollingListItems.length; i++){
                $(scrollingListItems[i]).css({
                    '-webkit-animation-delay': i*0.5 + 's',
                    'animation-delay':  i*0.5 + 's',
                    '-webkit-transition-delay': i*0.5 + 's',
                    'transition-delay': i*0.5 + 's'
                });
            }
        });

        $('.js-scroll-animation').each(function(){
            scrollAnimation($(this));
        });

        App.W.on('scrolled', function(){
            $('.js-scroll-animation:not(.animate__animated)').trigger('animate-visible');
        });

        App.W.on('resized', function () {
            $('.js-scroll-animation:not(.animate__animated)').trigger('animate-visible');
        });
    }

    $('.js-tab-title').on('click init', triggerAnimateVisible);

    $('.swiper-container').each(function (i, swiperDom) {
        loadLibrary(LIB_URL.SWIPER, () => {
            if (swiperDom.swiper) {
                swiperDom.swiper.slides.forEach(slideDom => {
                    const $animations = $('.js-scroll-animation, .js-scroll-animation-all-devices', slideDom);

                    $animations.each((i, animationDom) => {
                        if (!animationDom.hasScrollAnimation) {
                            scrollAnimation($(animationDom));
                        }
                    });
                });

                swiperDom.swiper.on('slideChange', triggerAnimateVisible);
            }
        });
    });

    $('.js-common-popup').each(function (i, popup) {
        $(popup).on('popup:opened', triggerAnimateVisible);
    });

    // $('.js-scroll-video').each(function(e, i) {
    //     $(this).find('video').removeAttr('autoplay');
    //     $(this).find('video').each(function(el, ind) {
    //         if (!$(this).paused && !$(this).data('shown')) {
    //             $(this).get(0).pause();
    //             $(this).get(0).currentTime = 0;
    //         }
    //         console.log('ind ' + $(this).get(0));
    //         // if (isInViewport(this)) {
    //         //     $(this).get(0).play();
    //         // }
    //     });
    //     if (isInViewport(this)) {
    //         console.log('i ' + this);
    //     }
    // });
});

function triggerAnimateVisible() {
    requestAnimationFrame(() => {
        if (!isTouchDevice()) {
            $('.js-scroll-animation:not(.animate__animated)').trigger('animate-visible');
        }
        $('.js-scroll-animation-all-devices:not(.animate__animated)').trigger('animate-visible');
    });
}

function isTouchDevice() {
    return App.mobile || App.W.width() < 1024;
}

function scrollAnimation(scrollingAnimElement){
    let scrollingBlock = scrollingAnimElement.parents('.js-scroll-animation-wrapper'),
        scrollingAnimation = scrollingAnimElement.data('anim'),
        parentTab = scrollingAnimElement.closest('.js-tab-content'),
        parentSlide = scrollingAnimElement.closest('.swiper-slide'),
        parentPopup = scrollingAnimElement.closest('.js-common-popup');

    scrollingAnimElement.on('animate-visible',() => {
        const hasParentTab = parentTab.length > 0;
        const hasParentSlide = parentSlide.length > 0;

        if (!scrollingBlock.offset()) return;

        if (App.W.scrollTop() + App.W.height() > scrollingBlock.offset().top){
            if (parentPopup.length && !parentPopup.hasClass('common-popup--opened')) {
                return;
            }
            if (hasParentTab && hasParentSlide) {
                if (!(parentTab.hasClass('_active') && parentSlide.hasClass('swiper-slide-active'))) return;
            } else
            if (hasParentTab && !parentTab.hasClass('_active')) {
                return;
            } else
            if (hasParentSlide && !parentSlide.hasClass('swiper-slide-active')) {
                return;
            }

            if (scrollingAnimation === 'animate__path') {
                const totalLenth = scrollingAnimElement[0].getTotalLength();

                scrollingAnimElement.attr('style', `stroke-dasharray: ${totalLenth}; stroke-dashoffset:${totalLenth}`);
            }

            if (scrollingAnimation === 'animate__path-dash') {
                const totalLenth = scrollingAnimElement[0].getTotalLength();

                scrollingAnimElement.attr('style', `stroke-dashoffset:${totalLenth}`);
            }

            if (scrollingAnimation === 'animate__pathInverse') {
                const totalLenth = scrollingAnimElement[0].getTotalLength();

                scrollingAnimElement.attr('style', `stroke-dasharray: ${totalLenth}; stroke-dashoffset:-${totalLenth}`);
            }
            scrollingAnimElement
                .addClass('animate__animated')
                .addClass(scrollingAnimation)
                .off('animate-visible');
        }
    });

    scrollingAnimElement.trigger('animate-visible');
}


// Запуск фонового видео при появлении на экране

let $scrollVideos = $('.js-scroll-video').find('video');

if ($scrollVideos.length) {
    $scrollVideos.each(function() {
        let $scrollVideo = $(this);

        if (!$scrollVideo.data('shown')) {
            $scrollVideo.removeAttr('autoplay');
            $scrollVideo.get(0).pause();
            $scrollVideo.get(0).currentTime = 0;
        }
    });

    window.addEventListener('scroll', handlerSV, false);

    handlerSV();
}

function handlerSV() {
    $scrollVideos.each(function() {
        let scrollVideo = this;
        let $scrollVideo = $(this);

        if (isInViewport(scrollVideo) && !$scrollVideo.data('shown')) {
            $scrollVideo.get(0).play();
            $scrollVideo.data('shown', true);
        }
    });
}
